import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FirebaseApp } from 'angularfire2';
import { Storage } from '@ionic/storage';
import { CommonProvider } from '../../providers/common/common';

@Injectable()
export class FirebaseMessagingProvider {
  private messaging;
  private unsubscribeOnTokenRefresh = () => {};

  constructor(
    public platform: Platform,
    private storage: Storage,
    private app: FirebaseApp,
    public comProv: CommonProvider,
  ) {}

  start() {
    if (this.comProv.isApp()) {
      return;
    }
    if (this.comProv.isIos()) {
      return;
    }
    if (!this.comProv.isPwaAccount()) {
      return;
    }
    if (this.comProv.isPc()) {
      return;
    }
    if (location.hash == '#/share' || location.hash == '#/privacy') {
      return;
    }

    try {
      this.messaging = this.app.messaging();
      navigator.serviceWorker.register('service-worker.js').then((registration) => {
        this.messaging.useServiceWorker(registration);
        //this.disableNotifications()
        this.enableNotifications()
        .catch(function(err) {
          console.log('Unable to get permission to notify. ', err);
        });
      });
    } catch(e) {
      console.log(e);
    }
  }

  public enableNotifications() {
    console.log('Requesting permission');
    return this.messaging.requestPermission().then(() => {
        console.log('Permission granted');
        this.setupOnTokenRefresh();
        return this.updateToken();
      });
  }

  public disableNotifications() {
    this.unsubscribeOnTokenRefresh();
    this.unsubscribeOnTokenRefresh = () => {};
    return this.storage.set('fcm_token','').then();
  }

  private updateToken() {
    return this.messaging.getToken().then((currentToken) => {
      if (currentToken) {
        return this.storage.set('fcm_token', currentToken);
      } else {
        console.log('No Instance ID token available. Request permission to generate one.');
      }
    });
  }

  private setupOnTokenRefresh(): void {
    this.unsubscribeOnTokenRefresh = this.messaging.onTokenRefresh(() => {
      console.log("Token refreshed");
      this.storage.set('fcm_token','').then(() => { this.updateToken(); });
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/firebase-messaging/firebase-messaging.ts